export default "__VITE_ASSET__CnNWrwK0__"